import { cloneDeep } from 'lodash';
import React, { useContext, useState } from 'react';
import { ContactInput } from 'sr-types/lib/person/v1/graphql';
import ContactRenderer from '../../../common/components/contacts/ContactRenderer';
import { ENTITY_CONSTANTS } from '../../../common/constants/entityConstants';
import { FormContext } from '../../../common/form/FormContext';
import { successToastMessage } from '../../../common/utils/commonUtils';
import { usePersonProvider } from '../../PersonContext';
import {
    removeBusinessContact,
    useDeleteBusinessContact,
    useGetPersonId
} from '../detailsPageUtilities/personBusinessContacts';

export default function BusinessContactSection({
    contact,
    onEdit,
    directDeleteContact = false
}: {
    contact: ContactInput;
    onEdit: (contact: ContactInput) => void;
    directDeleteContact?: boolean;
}) {
    const { state, handleChange } = useContext(FormContext);
    const { directDeleteBusinessContact, removingBusinessContact } = useDeleteBusinessContact();
    const { personId } = useGetPersonId();
    const { personData, setPersonData } = usePersonProvider();

    const [currentPerson, setCurrentPerson] = useState<string>(null);
    const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = useState<boolean>(false);
    const [deleteContact, setDeleteContact] = useState<ContactInput>(null);

    const onDeleteClicked = (contact: ContactInput) => {
        setDeleteContact(contact);
        setIsDeleteConfirmationOpen(true);
    };

    const handleDeleteConfirmed = async () => {
        if (directDeleteContact) {
            await directDeleteBusinessContact(personId, deleteContact);
        }
        const updatedBusinessContacts = removeBusinessContact(
            cloneDeep(state.businessContacts),
            deleteContact.personReference.id
        );
        handleChange('businessContacts', updatedBusinessContacts);
        !directDeleteContact
            ? successToastMessage('business.contact.remove.success')
            : setPersonData({ ...personData, businessContacts: updatedBusinessContacts });

        setIsDeleteConfirmationOpen(false);
    };

    return (
        <ContactRenderer
            contact={contact}
            setCurrentPerson={setCurrentPerson}
            onEdit={onEdit}
            onDeleteClicked={onDeleteClicked}
            isDeleteConfirmationOpen={isDeleteConfirmationOpen}
            handleDeleteConfirmed={handleDeleteConfirmed}
            removingBusinessContact={removingBusinessContact}
            setIsDeleteConfirmationOpen={setIsDeleteConfirmationOpen}
            currentPerson={currentPerson}
            entityName={ENTITY_CONSTANTS.person}
            hideBottomBorder
        />
    );
}
